import language from '@/views/Language/store/language'
import userSettings from '@/views/Language/store/userSettings'

export default {
    language,
    userSettings,
}
